import { useMemo } from "react";

import { GridRowsProp } from "@mui/x-data-grid";
import uniqueId from "lodash/uniqueId";
import uniqBy from "lodash/uniqBy";
import moment from "moment";

import {
  EVENTS_DATE_FORMAT,
  MITIGATED_RISK_SEPARATOR,
} from "../../common/events.constants";
import { getRowIndex } from "../../common/events.helpers";
import {
  IParsedRecentEvent,
  IRecentEventsTableRow,
} from "../../common/events.models";
import { useGetTimestreamDataServer } from "../../common/hooks/useGetTimestreamDataServer";

export const DEFAULT_RECENT_ACTIVITIES_PAGE_SIZE = 10;

export const DEFAULT_RECENT_ACTIVITIES_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export interface IEventsTableRow {
  rowId: string;
  location: string;
  timestamp: string;
  keyFrame: string;
  time: string;
}

export const useGetRecentEventsTableRows = () => {
  const {
    parsedResult,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
    queryInput,
  } = useGetTimestreamDataServer(DEFAULT_RECENT_ACTIVITIES_PAGE_SIZE);

  const rows = useMemo((): GridRowsProp<IRecentEventsTableRow> => {
    const uniqueRows = uniqBy(
      parsedResult,
      item => item?.id
    ) as IParsedRecentEvent[];

    const parsedData: IRecentEventsTableRow[] = uniqueRows?.map(
      (item: IParsedRecentEvent, index: number) => {
        const rowIndex = getRowIndex(paginationModel, index);

        return {
          rowIndex,
          rowId: item?.id ?? uniqueId(),
          location: item?.location_id ?? "",
          timestamp: moment.utc(item?.time).local().format(EVENTS_DATE_FORMAT),
          keyFrame: item?.keyFrame ?? "",
          mediaOutput: item?.mediaOutput ?? "",
          signedUrlKeyFrame: item?.signedUrlKeyFrame ?? "",
          signedUrlMediaOutput: item?.signedUrlMediaOutput ?? "",
          model: item?.model ?? "",
          zoneName: item?.zone_id ?? "",
          cameraId: item?.camera_id ?? "",
          time: item?.built_in_time ?? "",
          feedback: item?.feedback,
          mitigatedRisk:
            item?.mitigatedRisk?.split(MITIGATED_RISK_SEPARATOR) ?? [],
        };
      }
    );

    return parsedData;
  }, [parsedResult]);

  return {
    rows,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
    queryInput,
  };
};
